import './ActionsPanel.css';
import React from 'react';
import Loader from './loader';
var ProgressApplication = function ProgressApplication(_ref) {
  var rtl = _ref.rtl,
    actions = _ref.actions,
    buttonState = _ref.buttonState;
  var DEFAULT_BUTTON_STATE = {
    inactive: false,
    loading: false,
    label: 'button'
  };
  var _ref2 = buttonState || {},
    _ref2$continue = _ref2.continue,
    continueState = _ref2$continue === void 0 ? DEFAULT_BUTTON_STATE : _ref2$continue,
    _ref2$save = _ref2.save,
    saveState = _ref2$save === void 0 ? DEFAULT_BUTTON_STATE : _ref2$save,
    _ref2$back = _ref2.back,
    backState = _ref2$back === void 0 ? DEFAULT_BUTTON_STATE : _ref2$back;
  var _ref3 = actions || {},
    _ref3$backAction = _ref3.backAction,
    backAction = _ref3$backAction === void 0 ? function () {} : _ref3$backAction,
    _ref3$saveAction = _ref3.saveAction,
    saveAction = _ref3$saveAction === void 0 ? function () {} : _ref3$saveAction,
    _ref3$contionueAction = _ref3.contionueAction,
    contionueAction = _ref3$contionueAction === void 0 ? function () {} : _ref3$contionueAction;
  var continueEvent = function continueEvent(e) {
    e.preventDefault();
    if (!continueState.loading && !continueState.inactive) contionueAction();
  };
  var backEvent = function backEvent(e) {
    e.preventDefault();
    if (!backState.loading && !backState.inactive) backAction();
  };
  var saveEvent = function saveEvent(e) {
    e.preventDefault();
    if (!saveState.loading && !saveState.inactive) saveAction();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ")
  }, /*#__PURE__*/React.createElement("div", {
    className: " module-group module-group--inside"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel__wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary ".concat(backState.inactive ? 'disabled' : '', " d-none  d-sm-block  "),
    onClick: backEvent
  }, backState.label), /*#__PURE__*/React.createElement("div", {
    className: "button-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: " "
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-secondary ".concat(saveState.inactive ? 'disabled' : '', " ").concat(saveState.loading ? 'loading' : ''),
    onClick: saveEvent
  }, saveState.loading ? /*#__PURE__*/React.createElement(Loader, {
    className: "loader"
  }) : '', /*#__PURE__*/React.createElement("span", null, saveState.label))), /*#__PURE__*/React.createElement("div", {
    className: " "
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary ".concat(continueState.inactive ? 'disabled' : '', " ").concat(continueState.loading ? 'loading' : ''),
    onClick: continueEvent
  }, continueState.loading ? /*#__PURE__*/React.createElement(Loader, null) : '', /*#__PURE__*/React.createElement("span", null, continueState.label)))))));
};
export default ProgressApplication;
var commonStyles = "c1f0nh9r";
var rtlStyles = "rsdgvx8";
var ltrStyles = "lfdbze1";